var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import LifeBuoy02Svg from './life-buoy-02.icon.svg';
export const LifeBuoy02Icon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: LifeBuoy02Svg }));
_react_refresh_temp_1 = LifeBuoy02Icon;
$RefreshReg$(_react_refresh_temp_1, "LifeBuoy02Icon");
